import { Request } from '../../../../httpClient/serverApi/requests/Request';

export let UpdateStringServerSettingNames = {
  defaultLanguage:            'defaultLanguage',
  defaultLocale:              'defaultLocale',
  signInNoteText:             'signInNoteText',
  signInNoteUrl:              'signInNoteUrl',
  cloudIntegrationTableauServerId: 'cloudIntegrationTableauServerId',
  cloudIntegrationInstantAnalyticsApiKey: 'cloudIntegrationInstantAnalyticsApiKey'
};

export interface IUpdateStringServerSettingParams {
  setting: string;
  value: string;
  encrypt?: boolean;
}

export interface IUpdateStringServerSettingResult {
}

export class UpdateStringServerSettingRequest extends Request<IUpdateStringServerSettingParams, IUpdateStringServerSettingResult> {
  constructor(params: IUpdateStringServerSettingParams) {
    super('updateStringServerSetting', params);
  }
}
